import React, { useState, useEffect } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import ToastNotification from '../../../components/ToastNotification';
import ToastNotification_Second from '../../../components/ToastNotification_Second';
import Select from 'react-select'
import { useLoading } from '../../../context/LoadingContext';
import { io } from "socket.io-client";
import socket from "../../../socket";

const MaterialIssue = ({ adminData, branchID ,financialYear }) => {


    const getTodayDateTime = () => {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        return now.toISOString().slice(0, 16);
    };


    const [issue, setIssue] = useState({
        emp_id: '',
        issue_date: getTodayDateTime(),
        ref_doc: '',
        remark: '',

    })
    const [formData, setFormData] = useState([
        {
            id: '',
            qty: '',
            name: "",
            rate: '',
            amount: '',
            sr_no: '',
        }
    ]);

    const [files, setFiles] = useState({
        file: null,
        existing_file: null,

    })
    const { setLoading } = useLoading();
    const [isEditMode, setIsEditMode] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [user, setUser] = useState([]);
    const [items, setItems] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState("");
    const [tech, setTech] = useState([]);
    const [fetchIssue, setFetchIssue] = useState([])
    const [selectedTech, setSelectedTech] = useState(null);
    const [showItemModal, setShowItemModal] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [selectedDoc, setSelectedDoc] = useState(null)
    const [editingCompanyId, setEditingCompanyId] = useState(null)
    const [noteType, setNoteType] = useState(null);
    const [materialIssue, setMaterialIssue] = useState([]);
    const [branchDetail, setBranchDetail] = useState([])
    const [serialsByItem, setSerialsByItem] = useState({});
    const [issuedSerialsByItem, setIssuedSerialsByItem] = useState({});
    const [serialError, setSerialError] = useState({});
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

    const [allDocs, setAllDocs] = useState([]);
    const [filteredDocs, setFilteredDocs] = useState([]);
     
      const [offset, setOffset] = useState(0);
                      const limit = 20;
                      const [hasMore, setHasMore] = useState(true);
                      const [fromDate, setFromDate] = useState();
                      const [toDate, setToDate] = useState();
                      const [isLocked, setIsLocked] = useState(false);
                      const [fy, setFy] = useState([]);
                  
                      const [financialRange, setFinancialRange] = useState({
                          from_date: '',
                          to_date: ''
                      });
    
    useEffect(() => {
  if (!adminData.user.emp_id) return;

  socket.on("connect", () => {
    // console.log("Connected:", socket.id);

    socket.emit("register-user", adminData.user.emp_id);
    // console.log("Registered:", adminData.user.emp_id);
  });

  // If already connected
  if (socket.connected) {
    socket.emit("register-user", adminData.user.emp_id);
    // console.log("Registered:", adminData.user.emp_id);
  }

  return () => {
    socket.off("connect");
  };
}, [adminData.user.emp_id]);

useEffect(() => {
  const handleMaterial = (data) => {
    showToast(data.message, "info");
  };

  socket.on("material_issue", handleMaterial);

  return () => {
    socket.off("material_issue", handleMaterial);
  };
}, []);

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };


    const [secondToast, setSecondToast] = useState({
        show: false,
        message: '',
        bg: 'warning',
    });

    const showSecondToast = (msg, bg = 'warning') => {
        setSecondToast({ show: true, message: msg, bg });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setIssue(prev => ({ ...prev, [name]: value }));
    };


    const addRow = () => {
        setFormData(prev => [...prev, { id: "", name: "", qty: "" }]);
    };


    const usedRefDocs = new Set(
    materialIssue
        .map(mi => Number(mi.ref_doc))
        .filter(id => id && !isNaN(id))
);

const docOptions = fetchIssue
    .filter(item => {
        const itemId = Number(item.id);
        return itemId && !usedRefDocs.has(itemId);
    })
    .map(item => ({
        value: item.id,
        label: `MR/${item.id}/${item.branchId}`,
        data: item
    }));


    const typeOptions = [
        { value: "request", label: "Request" },
        { value: "return", label: "Return" }
    ];

    const handleItemChange = (index, itemId) => {
        const selectedItem = items.find(i => i.id === itemId);
        if (!selectedItem) return;

        setFormData(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                id: itemId,
                name: selectedItem.name
            };
            return updated;
        });
        fetchSerials(itemId, Number(formData[index]?.qty) || 0);
    };



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 2) {
                setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
                return;
            }
            setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
        }
    };

    const handleSelectDoc = (selectedOption) => {
        setSelectedDoc(selectedOption);

        if (selectedOption && selectedOption.data) {
            const s = selectedOption.data;


            setIssue({
                id: s.id,
                emp_id: s.emp_id,
                issue_date: s.issue_date,
                ref_doc: s.ref_doc,
                remark: s.remark,
            });

            const parsedItems = s.items ? JSON.parse(s.items) : [];
            setFormData(parsedItems);

            parsedItems.forEach(item => {
                if (item.id && Number(item.qty) > 0) {
                    fetchSerials(item.id, Number(item.qty));
                }
            });

            setFiles({
                file: null,
                existing_file: s.file || null,
            });

            const techOption = options.find(o => o.value === s.emp_id) || null;
            setSelectedTech(techOption);
            setNoteType(s.material_status || null)

        }
    };




const handleTechChange = (selectedOption) => {
    setSelectedTech(selectedOption);

    if (selectedOption) {

   
        const usedRefDocs = new Set(
            materialIssue
                .map(mi => Number(mi.ref_doc))
                .filter(id => !isNaN(id))
        );

        const filtered = fetchIssue.filter(item => {
            const empMatch = String(item.emp_id) === String(selectedOption.value);
            const itemId = Number(item.id);

            return empMatch && !usedRefDocs.has(itemId);
        });

        const docOptions = filtered.map(item => ({
            value: item.id,
            label: item.ref_doc || `MR/${item.id}/${item.branchId}`,
            data: item
        }));

        setFilteredDocs(docOptions);

    } else {
        setFilteredDocs([]);
    }

    setSelectedDoc(null);
};

    const fectEmphDetail = async () => {
        try {
            const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
               const filtered = (resEmployee.data.result || []).filter(
      emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== ""
    );

    setUser(filtered);
        } catch (error) {
            console.log(error)
        }
    };


    const options = user.map(t => ({
        value: t.id,
        label: `${t.first} ${t.middle}  ${t.last} - ${t.emp_id}`
    }));

    const fecthInventoryDetail = async () => {
        try {
            const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');


            const items = resInventory.data.result || [];
            setItems(items);
        } catch (error) {
            console.log(error)
        }
    };

    const fecthTechDetail = async () => {
        try {
            const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-technician');
            setTech(resEmployee.data);
        } catch (error) {
            console.log(error)
        }
    };


    const fetchMaterialIssue = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {

                if (!branchCode) {
            console.log("Branch code missing");
            return;
        }

        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-material-isssue',
                 {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }
            );
          

               const filteredData = res.data
            .filter(item => item.material_status === 'request')
            .sort((a, b) => b.id - a.id); 

        // setMaterialIssue(filteredData);
             const result = filteredData;
            if (newOffset === 0) {
                setMaterialIssue(result);
                setHasMore(true);
            }

            else {
                setMaterialIssue(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }

            setAllDocs(filteredData)
        } catch (error) {
            console.log(error);
        }
    };


     const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const purchaseRequisition = async () => {
        try {
            const result = await axios.get('https://api.skyguard.group/api/fetch-requisition');
            setFetchIssue(result.data);
        } catch (error) {
            console.log(error)
        }
    };





    const fetchSerials = async (inventoryId, qty) => {
        if (!inventoryId) return;

        try {
            const res = await axios.get(
                "https://api.skyguard.group/api/fetch-inventory-serials",
                { params: { inventory_id: inventoryId } }
            );

            const flattened = Array.isArray(res.data[0]) ? res.data.flat() : res.data;


            const unsoldSerials = Array.from(
                new Map(flattened.map(s => [s.id, s])).values()
            ).filter(s => !s.sold_on || s.sold_on === 0);

            setSerialsByItem(prev => ({
                ...prev,
                [inventoryId]: unsoldSerials
            }));


            if (qty > unsoldSerials.length) {
                setSerialError(prev => ({
                    ...prev,
                    [inventoryId]: `Not enough serial numbers .`
                }));
            } else {
                setSerialError(prev => ({
                    ...prev,
                    [inventoryId]: null
                }));
            }



        } catch (err) {
            console.error("Error fetching serials:", err);
        }
    };


       const fetchYearDetail = async () => {
                            setLoading(true);
                            try {
                                const branchCode = await fetchBranchDetail();
                                const res = await axios.get(
                                    `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
                                );
                                const yearData = res.data;
                                setFy(yearData);
                                setIsLocked(yearData.is_locked === 1);
                                setFinancialRange({
                                    from_date: yearData.from_date,
                                    to_date: yearData.to_date
                                });
                    
                                await fetchMaterialIssue(
                                    yearData.from_date,
                                    yearData.to_date,
                                    branchCode,
                    
                                );
                            } catch (error) {
                                console.log(error);
                            } finally {
                                setLoading(false);
                            }
                        };


    useEffect(() => {

        fectEmphDetail();
        fecthInventoryDetail();
        fecthTechDetail();
        purchaseRequisition();
      fetchYearDetail();
        fetchBranchDetail();
    }, []);


    const fullName = `${adminData?.user.first || ''} ${adminData?.user.middle || ''} ${adminData?.user.last || ''}`.trim();

    const editName = `${adminData?.user.first || ''} ${adminData?.user.middle || ''} ${adminData?.user.last || ''}`.trim();




    const handleSubmit = async (e) => {
        e.preventDefault();

        const itemsWithSerials = formData.map((item, index) => ({
            ...item,
            sr_no: getSerialNumbers(item.id, item.qty, index)
        }));

    const invalidItems = itemsWithSerials.filter(item => {
  const qty = Number(item.qty) || 0;

  return (
    qty > 0 &&
    (!item.sr_no ||
      !Array.isArray(item.sr_no) ||
      item.sr_no.length !== qty)
  );
});

if (invalidItems.length > 0) {
  showToast(
    "Please select serial numbers for all serialized items.",
    "danger"
  );
  return;
}

        const cleanedItems = itemsWithSerials
            .filter(i => i.id && i.qty)
            .map(i => ({
                id: i.id,
                name: i.name,
                qty: Number(i.qty),
                sr_no: i.sr_no,
                rate: i.rate || 0,
                amount: i.amount || 0,
            }));

        const sendData = new FormData();
        sendData.append('ref_doc', selectedDoc?.value || '');
        sendData.append("note_type", "material_issue");
        sendData.append("emp_id", selectedTech?.value || "");
        sendData.append("material_status", "request");
        sendData.append("issue_date", issue.issue_date || new Date().toISOString().slice(0, 16));
        sendData.append("remark", issue.remark);
        sendData.append("items", JSON.stringify(cleanedItems));
        sendData.append("existing_file", files.existing_file || "");

        sendData.append('added_by', fullName)
        sendData.append("branchId", branchDetail.code);

        if (files.file) {
            sendData.append("file", files.file);
        }

        try {
            if (isEditMode && editingCompanyId) {
                sendData.append("edit_by", editName);
                await axios.put(
                    `https://api.skyguard.group/api/update-material-issue-note/${editingCompanyId}`,
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                showToast("Material issue updated successfully!", "success");
            } else {

                await axios.post(
                    "https://api.skyguard.group/api/material-issue-note",
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                showToast("Material issue note created  successfully!", "success");
            }

            // fecthissueDetail();
            setShowAddForm(false);
            setIsEditMode(false);

            setIssue({
                emp_id: '',
                issue_date: '',
                ref_doc: '',

                remark: '',
            })

            setFormData([]);
            setNoteType([])
            setSelectedTech(null)
            setSelectedDoc([]);

            fetchMaterialIssue(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
        } catch (err) {
            console.error("❌ Error:", err.response?.data || err.message);
            showToast(
                err.response?.data?.error || (isEditMode
                    ? "Failed to update material issue note!"
                    : "Failed to create material issue note!"),
                "danger"
            );
        }
    };
 const resetForm = () =>{

    // setShowAddForm(false);
            setIsEditMode(false);

            setIssue({
                emp_id: '',
                issue_date: '',
                ref_doc: '',

                remark: '',
            })

            setFormData([]);
            setNoteType([])
            setSelectedTech(null)
            setSelectedDoc([]);
 }

    const handleEdit = (s) => {

        let parsedItems = [];
        try {
            parsedItems = s.items ? JSON.parse(s.items) : [];
        } catch (err) {
            console.error("❌ Error parsing items JSON:", err);
        }

        const itemsWithSerials = parsedItems.map(item => ({
            ...item,
            sr_no: Array.isArray(item.sr_no) ? item.sr_no : [],
        }));

        const issuedSerials = {};
        itemsWithSerials.forEach(item => {
            issuedSerials[item.id] = [...(issuedSerials[item.id] || []), ...item.sr_no];
            fetchSerials(item.id, Number(item.qty) || 0);
        });
        setIssuedSerialsByItem(issuedSerials);

        // ✅ Then set form data
        setFormData(itemsWithSerials);

        setIssue({
            id: s.id || '',
            emp_id: s.emp_id || '',
            issue_date: s.issue_date || '',
            ref_doc: s.ref_doc || '',
            remark: s.remark || '',
              branchId:s.branchId || "",
        });


        setFiles({
            file: null,
            existing_file: s.file || null,
        });


        const tech = options.find(opt => opt.value === s.emp_id);
        setSelectedTech(tech || null);
        setNoteType(s.material_status || null);

        const docOption = docOptions.find(
            opt => opt.value === Number(s.ref_doc)
        );
        setSelectedDoc(docOption || {
            value: Number(s.ref_doc),
            label: `MR/${s.ref_doc}/${s.branchId}`
        });

        setEditingCompanyId(s.id);
        setIsEditMode(true);
        setShowAddForm(true);
    };



    const getSerialNumbers = (inventory_id, qty, rowIndex) => {
        if (!inventory_id || !qty) return [];

        const issued = isEditMode ? issuedSerialsByItem[inventory_id] || [] : [];
        const available = (serialsByItem[inventory_id] || []).map(s => s.sr_no);
        const offset = formData.slice(0, rowIndex).reduce((total, item) =>
            String(item.id) === String(inventory_id) ? total + Math.max(0, Number(item.qty) || 0) : total, 0);
        return Array.from(new Set([...issued, ...available])).slice(offset, offset + Number(qty));
    };



    const filteredData = searchTerm
        ? materialIssue.filter(itm =>
            Object.values(itm).some(val =>
                String(val || '').toLowerCase().includes(searchTerm.toLowerCase())
            )
        )
        : materialIssue;

    const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

        fetchMaterialIssue(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };


    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Material Issue</h3>
                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />

                    <ToastNotification_Second
                        show={secondToast.show}
                        message={secondToast.message}
                        bg={secondToast.bg}
                        onClose={() => setSecondToast({ ...secondToast, show: false })}
                    />

                    <div className="mb-3 row gx-2 gy-2 d-flex justify-content-between">


                        <div class="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">

                            <div class="col-12 col-md-9">
                                <div className="row my-3 align-items-center">
                                    {/* Input */}
                                    <div className="col-md-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search By name,type"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>



                            </div>

                            <div className="col-12 col-md-2 d-flex justify-content-end">
                                <button
                                    className={`btn ${showAddForm ? 'btn-danger' : 'btn-success'}`}
                                    onClick={() => {
                                        setShowAddForm(!showAddForm);
                                          resetForm(); 
                                    }}
                                >
                                    {showAddForm ? 'Cancel' : 'Add'}{' '}
                                    {showAddForm ? <FaTimes size={18} /> : <AiOutlinePlusCircle size={20} />}
                                </button>
                            </div>

                        </div>


                    </div>

                    {showAddForm && (
                        <div className='card p-3 mb-4'>

                                                           {isEditMode && (
  <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">

      {`MIN/${issue.issue_id || issue.id}/${issue.branchId || ""}`}
    </span>
  </div>
)}

                            <form className='row g-3' onSubmit={handleSubmit} >

                                

                                <div className="col-md-4">
                                    <label>Select Technician Name</label>
                                    <Select
                                        options={options}
                                        value={selectedTech}
                                        onChange={handleTechChange}
                                        placeholder="Select Technician"
                                        isClearable
                                    />
                                </div>

                                {/* <div className="col-md-4">
                                    <label> Reference</label>
                                    <Select
                                        options={docOptions}
                                        value={selectedDoc}
                                        onChange={handleSelectDoc}
                                        placeholder="Select MR"
                                        isClearable
                                    />
                                </div> */}

                                <div className="col-md-4">
                                    <label>Reference Document</label>
                                    <Select
                                        options={filteredDocs}
                                        value={selectedDoc}
                                        onChange={handleSelectDoc}
                                        placeholder="Select Reference"
                                        isDisabled={!selectedTech}
                                        isClearable
                                    />
                                </div>


                                <div className="col-md-4">
                                    <laebl>Date</laebl>
                                    <input
                                        type="datetime-local"
                                        className="form-control"

                                        name="issue_date"
                                        value={issue.issue_date}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="table-responsive my-4">

                                    <div className="col-md-12 text-end mb-2">
                                        <button
                                            type='button'
                                            className="btn btn-success"
                                            onClick={addRow}
                                        >
                                            + Add Row
                                        </button>
                                    </div>


                                    <table className="table table-bordered mx-auto text-center align-middle w-75">
                                        <thead className="table-primary">
                                            <tr>
                                                <th style={{ width: "300px" }}>Item</th>
                                                <th style={{ width: "100px" }} >Qty</th>
                                                <th style={{ width: "100px" }} >Sr No.</th>
                                                <th style={{ width: "100px" }}>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {formData.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary w-100"
                                                            onClick={() => {
                                                                setActiveRowIndex(idx);
                                                                setShowItemModal(true);
                                                            }}
                                                        >
                                                            {item.name ? item.name : "Search Item"}
                                                        </button>
                                                    </td>


                                                    {/* Qty */}
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={item.qty}
                                                            onChange={(e) => {
                                                                const updated = [...formData];
                                                                updated[idx].qty = e.target.value;
                                                                setFormData(updated);
                                                                fetchSerials(item.id, Number(e.target.value) || 0);
                                                            }}
                                                        />
                                                    </td>
                                                    <td>

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            readOnly
                                                            value={
                                                                getSerialNumbers(item.id, item.qty, idx).join(", ")
                                                            }
                                                        />


                                                        {serialError[item.id] && getSerialNumbers(item.id, item.qty, idx).length < Number(item.qty) && (
                                                            <small className="text-danger">{serialError[item.id]}</small>
                                                        )}
                                                    </td>

                                                    {/* Delete */}
                                                    <td>
                                                        <button
                                                            type='button'
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() =>
                                                                setFormData(formData.filter((_, i) => i !== idx))
                                                            }
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>




                                <div className="row">

                                    <div className="col-md-6">
                                        <label>Upload attachment</label>

                                        {isEditMode && files.existing_file && (
                                            <div className="mt-2">
                                                <small>Current File:</small>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.existing_file}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.existing_file}
                                                </a>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="attachment"
                                            name="file"
                                            accept="image/*,application/pdf"
                                            onChange={handleFileChange}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label>Remark</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            rows="5"
                                            placeholder="Enter description here..."
                                            name="remark"
                                            value={issue.remark}
                                            onChange={handleInputChange}
                                            disabled={isEditMode}
                                        ></textarea>
                                    </div>


                                </div>



                                <div className="col-md-12 d-grid d-flex justify-content-end">
                                    {/* <button type='submit' className="btn btn-primary">
                                    Save
                                </button> */}
                                    <button type="submit" className='btn btn-success w-10'>
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                        setShowAddForm(false);
                                        setIsEditMode(false);
                                        setIssue({
                                            emp_id: '',
                                            issue_date: '',
                                            ref_doc: '',

                                            remark: '',
                                        })
                                        setFormData([]);
                                        setNoteType([])
                                        setSelectedTech([]);
                                        setSelectedDoc([]);
                                    }}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* table */}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th scope='col'>SN</th>
                                       <th scope='col'>Action</th>
                                    <th scope='col'>Doc No.</th>
                                    <th scope='col'>Techinician</th>

                                    <th scope='col'>Added By</th>
                                    <th scope='col'>Added Date</th>
                                    <th scope='col'>Edit By</th>
                                    <th scope='col'>Edit Date</th>
                                 
                                </tr>
                            </thead>
                            <tbody>

                                {filteredData.map((s, idx) => (
                                    <tr key={idx}>
                                         <td>{filteredData.length - idx}</td>
                                           <td>
                                            <button type="button"
                                                className='btn btn-primary mx-2'
                                                onClick={() => handleEdit(s)}

                                            >

                                                <AiOutlineEdit size={20} title='Edit' />
                                            </button>
                                        </td>
                                        <td> {`MIN/${s.id}/${s.branchId}/${fy.financial_year.split('-')[0]}`} </td>

                                        <td>
                                            {[
                                                s.tech_first_name,
                                                s.tech_middle_name,
                                                s.tech_last_name
                                            ]
                                                .filter(Boolean)
                                                .join(" ")}
                                        </td>


                                        <td>{s.added_by} </td>
                                        <td> {s.issue_date} </td>
                                        <td>{s.edit_by} </td>
                                        {/* <td>{s.edit_date || '-'} </td> */}
                                        <td>
                                            {/* {new Date(s.edit_date).toLocaleString("en-IN", {
                                                timeZone: "Asia/Kolkata"
                                            })} */}
                                             {s.edit_date
    ? new Date(s.edit_date).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata"
      })
    : "-"}
                                        </td>

                                      
                                    </tr>
                                ))}

                                {filteredData.length === 0 && (
                                    <tr>
                                        <td colSpan="6" className='text-center text-muted'>
                                            No records found.
                                        </td>
                                    </tr>
                                )}


                            </tbody>
                        </table>
                    </div>
                    {showItemModal && (
                        <div className="modal fade show d-block " style={{ background: "rgba(0,0,0,.5)" }}>
                            <div className="modal-dialog modal-lg ">
                                <div className="modal-content ">

                                    <div className="modal-header">
                                        <h5 className="modal-title">Select Item</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowItemModal(false)}
                                        />
                                    </div>

                                    <div className="modal-body">
                                        {/* 🔍 Search */}
                                        <input
                                            type="text"
                                            className="form-control mb-3"
                                            placeholder="Search by item name..."
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />

                                        {/* Item list */}
                                        <div className='table-responsive'>
                                            <table className="table table-bordered ">
                                                <thead className='table-dark'>
                                                    <tr>
                                                        <th>Name</th>
                                                        {/* <th>Stock</th> */}
                                                        <th width="100">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {items
                                                        .filter(i =>
                                                            i.name.toLowerCase().includes(searchText.toLowerCase())
                                                        )
                                                        .map(i => (
                                                            <tr key={i.id}>
                                                                <td>{i.name}</td>
                                                                {/* <td>{i.stock}</td> */}
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-success"
                                                                        onClick={() => {
                                                                            handleItemChange(activeRowIndex, i.id);
                                                                            setShowItemModal(false);
                                                                            setSearchText("");
                                                                        }}
                                                                    >
                                                                        Select
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                          {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}

                                    </div>

                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
export default MaterialIssue
